<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 19.7981L20.4453 14.1679C20.9048 13.8616 21.5257 13.9858 21.832 14.4453C22.1165 14.872 22.0298 15.4378 21.648 15.7618L21.5547 15.8321L12.5547 21.8321C12.2561 22.0311 11.8772 22.0532 11.5607 21.8984L11.4453 21.8321L2.44528 15.8321C1.98576 15.5257 1.86158 14.9048 2.16793 14.4453C2.4524 14.0186 3.00806 13.881 3.45392 14.1089L3.55468 14.1679L12 19.7981L20.4453 14.1679L12 19.7981ZM12.5547 2.16795L21.5547 8.16795C22.1484 8.56377 22.1484 9.43623 21.5547 9.83205L12.5547 15.8321C12.2188 16.056 11.7812 16.056 11.4453 15.8321L2.44528 9.83205C1.85155 9.43623 1.85155 8.56377 2.44528 8.16795L11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795ZM12 4.20185L4.80276 9L12 13.7981L19.1972 9L12 4.20185Z"
    fill="currentColor"
  />
</svg>
